var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",class:_vm.skinName},[(_vm.todayQueueInfo == null)?_c('div',[_c('van-empty',{attrs:{"description":"当日未体检，无排队信息！"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }